import { FormContext } from 'components/common/FormProvider';
import React, { useContext, useEffect, useImperativeHandle, useRef, useState } from 'react';
import {
  editTableDataInGlobalObject,
  getFormProvidersDataFromGlobalObject,
  put42ServicesInGlobalObject
} from 'utils/hcfa/putFormProvidersDataInGlobalObject';
import { UB04_FIELDS } from 'utils/ub04';

interface Props {
  fields: any[];
  tableTotalsRef: React.MutableRefObject<any>;
}

const TableTotals: React.FC<Props> = ({ fields, tableTotalsRef }) => {
  const methodsUb = useContext(FormContext).methodsUb;

  const { setValue, watch, getValues } = methodsUb;
  // const initialCalculationDone = useRef(false);

  const [totalChargesSum, setTotalChargesSum] = useState<number>(0);
  const [nonCoveredCharges, setNonCoveredCharges] = useState<number>(0);
  const { setData } = useContext(FormContext);

  const tableValues = watch('42Services');
  useEffect(() => {
    put42ServicesInGlobalObject(tableValues);
  }, [tableValues]);
  useEffect(() => {
    const tableValues = getValues('42Services');
    calculateTotalFees(tableValues);
  }, [tableValues?.length]);
  // console.log({ tableValues });
  // useEffect(() => {
  //   if (initialCalculationDone.current) return;
  //   if (!tableValues.length) return;
  //   console.log('inside ');
  //   if ((tableValues.length = 1)) {
  //     const firstRow = tableValues[0];
  //     const totalChargeRowVal = firstRow?.[UB04_FIELDS.total_charges_47];
  //     const nonCoveredChargesVal = firstRow?.[UB04_FIELDS.nonCoveredCharges_48];
  //     if (totalChargeRowVal !== undefined || nonCoveredChargesVal !== undefined) {
  //       calculateTotalFees(tableValues);
  //       initialCalculationDone.current = true;
  //     }
  //   } else {
  //     console.log('ca;culating ', tableValues);
  //     calculateTotalFees(tableValues);
  //     initialCalculationDone.current = true;
  //   }
  // }, [tableValues]);

  useImperativeHandle(tableTotalsRef, () => ({
    handleTotalfeesCalculation: () => {
      const tableValues = getValues('42Services');

      calculateTotalFees(tableValues);
      handleField43Description(tableValues);
    }
  }));

  function conditionalSetValue(field: string, value: any) {
    // @ts-expect-error
    const valueInForm = getValues(field);

    if (valueInForm !== value) {
      // @ts-expect-error
      setValue(field, value);
    }
  }

  function calculateTotalFees(tableValues: any[]) {
    if (!Array.isArray(tableValues)) return;

    // const now = performance.now();
    // console.log('performance ', now);

    let totalChargesSum = 0;
    let nonCovChargesSum = 0;

    tableValues.forEach((row, i) => {
      const totalChargeRowVal = parseFloat(row?.[UB04_FIELDS.total_charges_47] || 0);
      const nonCoveredChargesVal = parseFloat(row?.[UB04_FIELDS.nonCoveredCharges_48] || 0);

      totalChargesSum += totalChargeRowVal;
      nonCovChargesSum += nonCoveredChargesVal;

      const sumAsString = (totalChargeRowVal + nonCoveredChargesVal).toFixed(2);
      editTableDataInGlobalObject(['42Services', i, UB04_FIELDS.ub49], sumAsString);

      setValue(`42Services.${i}.${UB04_FIELDS.ub49}`, sumAsString);
      //   setValue(`42Services.${i}.${UB04_FIELDS.ub49}` as const, sumAsString);
      //   console.log('sumAsString', sumAsString);
      //   form?.setFieldValue(['42Services', i, UB04_FIELDS.ub49], sumAsString);

      // const ub49Value = totalChargesSum.toFixed(2);
      // const valToSet = ub49Value.endsWith('.00') ? ub49Value : ub49Value.replace(/\.0$/, '');
      // setData({ ...getFormProvidersDataFromGlobalObject(), [UB04_FIELDS.ub49]: valToSet });

      // conditionalSetValue(UB04_FIELDS.ub49, valToSet);
      // form?.setFieldsValue({
      //   [UB04_FIELDS.ub49]: valToSet
      // });
    });

    setTotalChargesSum(totalChargesSum);
    setData({ ...getFormProvidersDataFromGlobalObject(), '49ub_total_charges_sum': totalChargesSum.toFixed(2) });
    conditionalSetValue('49ub_total_charges_sum', totalChargesSum.toFixed(2));
    // setValue('49ub_total_charges_sum', totalChargesSum.toFixed(2));
    // form?.setFieldsValue({
    //   '49ub_total_charges_sum': totalChargesSum.toFixed(2)
    // });

    setNonCoveredCharges(nonCovChargesSum);
    // console.log('calc took ', performance.now() - now);
  }

  function handleField43Description(tableValues: any[]) {
    tableValues?.forEach((row: any, i: any) => {
      const field1 = row?.[UB04_FIELDS.desc_ndc_code] || '';
      const field2 = row?.[UB04_FIELDS.desc_ndc_qty] || '';
      const field3 = row?.[UB04_FIELDS.desc_ndc_unit] || '';
      const descField = row?.[UB04_FIELDS.hcpcs_description_44];
      const combinationOfFieldf = `${field1} ${field2} ${field3}`;

      if (field1 || field2 || field3) {
        editTableDataInGlobalObject(['42Services', i, UB04_FIELDS.field_43_description], combinationOfFieldf.trim());
        conditionalSetValue(`42Services.${i}.${UB04_FIELDS.field_43_description}` as const, combinationOfFieldf.trim());
        // setValue(`42Services.${i}.${UB04_FIELDS.field_43_description}` as const, combinationOfFieldf.trim());
        // form?.setFieldValue(['42Services', i, UB04_FIELDS.field_43_description], combinationOfFieldf.trim());
      } else {
        editTableDataInGlobalObject(['42Services', i, UB04_FIELDS.field_43_description], descField);
        conditionalSetValue(`42Services.${i}.${UB04_FIELDS.field_43_description}` as const, descField);
        // setValue(`42Services.${i}.${UB04_FIELDS.field_43_description}` as const, descField);
        // form?.setFieldValue(['42Services', i, UB04_FIELDS.field_43_description], descField);
      }
    });
  }

  if (fields?.length > 0) {
    return (
      <div className="flex bt-2 bb-2 bold">
        <div className="padding-5" style={{ width: '13%' }}></div>
        <div className="padding-5" style={{ width: '15%' }}></div>
        <div className="padding-5 float-right" style={{ width: '10%' }}></div>
        <div style={{ width: 'calc(12% - 22px)' }}></div>
        <div className="padding-5" style={{ width: '11%' }}></div>
        <div className="padding-5 br-2" style={{ width: 'calc(11% - 5px)' }}>
          {'TOTALS'}
        </div>
        <div className="padding-5 br-2" style={{ width: 'calc(10% - 2px)' }}>
          {totalChargesSum.toFixed(2)}
        </div>
        <div className="padding-5" style={{ width: '10%' }}>
          {nonCoveredCharges.toFixed(2)}
        </div>
        <div style={{ width: '8%' }}></div>
      </div>
    );
  }
  return null;
};

export default TableTotals;
